import type { PlatformEvent } from '@/platform/events/EventModels';

export type PlatformEventHandler = (
  event: PlatformEvent,
) => void | Promise<void>;

class EventBus {
  private readonly subscribers = new Set<PlatformEventHandler>();

  subscribe(handler: PlatformEventHandler): () => void {
    this.subscribers.add(handler);

    return () => {
      this.subscribers.delete(handler);
    };
  }

  publish(event: PlatformEvent): void {
    this.subscribers.forEach((subscriber) => {
      void Promise.resolve(subscriber(event));
    });
  }
}

export const platformEventBus = new EventBus();
